module.exports = __webpack_public_path__ + "img/edit_white.6aca48db.svg";